/**
 * Many checks inside this file (isWeb, isSmallScreen, isBigScreen etc.) are used for the specific purpose
 * of making the WelcomeScreen compliant with the SC 1.4.10: Reflow (Level AA) accessibility rule.
 *
 * When making changes to this file, please re-validate the UI using the following steps:
 * 1. Set the browser width to 1280px
 * 2. Set the browser zoom to 400%
 * 3. Check if the content is readable vertically and no horizontal scrolling is allowed
 * 4. If the content is not readable vertically or horizontal scrolling is allowed, please adjust the
 *    checks in this file accordingly.
 */
import { View, Image } from 'react-native'
import styled from 'styled-components/native'
import { isWeb } from 'APP/Helpers/checkPlatform'

import Config from 'APP/Config'
import { SlideData } from '.'

export const StyledViewContainer = styled(View)<{ slideIndex: number }>`
  flex: 1;
  background-color: ${({ theme: { isBigScreen, colors }, slideIndex }) =>
    isBigScreen
      ? 'auto'
      : colors[`${`welcomeScreenBackgroundSlide${slideIndex}` as keyof typeof colors}`]};
  flex-direction: ${({ theme: { isBigScreen } }) => (isBigScreen ? 'row' : 'column')};
  align-items: center;
  justify-content: ${({ theme: { isSmallScreen } }) =>
    isWeb() && isSmallScreen ? 'flex-start' : 'center'};
`

export const StyledViewHero = styled(View)`
  flex-direction: column;
  align-items: center;
  flex: ${({ theme: { isSmallScreen } }) => (isWeb() && isSmallScreen ? '0 0 auto' : '1')};
  width: ${({ theme: { isBigScreen } }) => (isBigScreen ? '50%' : '100%')};
`

export const StyledViewCTAs = styled(View)<{ hasDialogueBranding?: boolean }>`
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${({ theme: { isBigScreen } }) => (isBigScreen ? '100%' : 'auto')};
  width: ${({ theme: { isBigScreen } }) => (isBigScreen ? '50%' : '100%')};
  position: ${({ theme: { isBigScreen, isSmallScreen } }) =>
    isBigScreen || (isWeb() && isSmallScreen) ? 'relative' : 'absolute'};
  bottom: ${({ theme: { isBigScreen, isSmallScreen }, hasDialogueBranding }) =>
    isBigScreen || (isWeb() && isSmallScreen) ? 'auto' : hasDialogueBranding ? '0' : '5%'};
  padding: ${({ theme: { metrics } }) => `${metrics.baseMargin}px`};
`

export const StyledViewQRContainer = styled(View)`
  position: ${({ theme: { isBigScreen, isSmallScreen } }) =>
    isBigScreen ? 'absolute' : isWeb() && isSmallScreen ? 'relative' : 'sticky'};
  bottom: ${({ theme: { isSmallScreen, metrics } }) =>
    isWeb() && isSmallScreen ? 'auto' : `${metrics.baseMargin * 2}px`};
  width: inherit;
  align-items: center;
`

export const StyledViewCarousel = styled(View)<{ slideIndex: number }>`
  height: ${({ theme: { isSmallScreen } }) => (isWeb() && isSmallScreen ? 'auto' : '100%')};
  width: 100%;
  background-color: ${({ theme: { isBigScreen, colors }, slideIndex }) =>
    isBigScreen
      ? colors[`${`welcomeScreenBackgroundSlide${slideIndex}` as keyof typeof colors}`]
      : 'auto'};
`

export const StyledImageHero = styled(Image)`
  flex: ${({ theme: { isBigScreen } }) => (isBigScreen ? '0.7' : '1')};
  width: auto;
  ${({ theme: { isBigScreen, metrics } }) =>
    (!Config.WELCOMESCREEN || !Config.WELCOMESCREEN.SLIDE_IMAGE_STRETCH) &&
    `
  padding: ${metrics.baseMargin}px;
  margin-top: ${isBigScreen ? '0' : `${metrics.baseMargin}px`};
  `}
`

export const StyledViewCTAsContainer = styled(View)`
  ${({ theme: { isSmallScreen } }) => isSmallScreen && 'width: 100%;'}
  max-width: ${({ theme: { isBigScreen } }) => (isBigScreen ? '80%' : '100%')};
  padding: ${({ theme: { metrics } }) => metrics.baseMargin}px;
`

export const StyledViewTextContainer = styled(View)`
  text-align: center;
  padding: ${({ theme: { metrics } }) => metrics.baseMargin}px;
  gap: ${({ theme: { metrics } }) => metrics.baseMargin}px;
  align-items: center;
`

export const StyledViewImageContainer = styled(View)<{ item: SlideData }>`
  flex: 1;
  background-color: ${({ item: { color } }) => color};
`

export const StyledImageLogo = styled(Image)`
  height: 45px;
  width: 45px;
  resize-mode: contain;
`

export const StyledViewDotsContainer = styled(View)`
  flex-direction: row;
  position: ${({ theme: { isSmallScreen } }) =>
    isWeb() && isSmallScreen ? 'relative' : 'absolute'};
  bottom: ${({ theme: { isBigScreen, isSmallScreen } }) =>
    isBigScreen ? '5%' : isWeb() && isSmallScreen ? 'auto' : '32%'};
`

export const StyledViewButtonsContainer = styled(View)`
  gap: ${({ theme: { metrics } }) => metrics.baseMargin}px;
`

export default {
  icon: {
    height: 40,
    width: 100,
  },
}
